import ListAltIcon from '@material-ui/icons/ListAlt';
import { Venture } from '../../api/ventures/types/Venture';
import { getRoutePath, Pages } from '../../router/constants';
import PopupIcon from '../common/popup-icon';

interface DescriptionIconProps {
  venture: Venture;
}

function DescriptionIcon({ venture }: DescriptionIconProps) {
  return (
    <PopupIcon
      to={{
        pathname: getRoutePath(Pages.VENTURE_DETAILS, {
          ventureId: venture.id,
        }),
        search: 'anchor=description',
      }}
      icon={<ListAltIcon />}
      content={venture.description}
      testId='description-icon'
      isNoIcon={!venture.description}
      emptyText='There is no description available.'
    />
  );
}

export default DescriptionIcon;
